<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <b-field>
        <b-input v-model="mutableField" type="textarea"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Annulla
      </button>
      <button class="button is-primary" @click="submit()">Conferma</button>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mutableField: this.field
    }
  },
  methods: {
    submit() {
      this.$emit("update", this.mutableField)
      this.$parent.close()
    }
  }
}
</script>
